import { AppRoutes, ButtonTypes } from 'types';
import { translate } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import { STUDENT_APP_DEFAULT_PADDING } from '@monorepo/shared/src/types';

const t = (key: string, options?) => translate('reports', key, options);

const alphabet = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z',
];

const backButtonConfig = {
  secondaryLeftButton: {
    name: ButtonTypes.BACK_BUTTON,
    redirectRoute: { path: `/${AppRoutes.REPORTS}` },
  },
};
const familyResourcesButtonConfig = {
  secondaryRightButton: {
    name: ButtonTypes.FAMILY_RESOURCES_BUTTON,
    showTextLabel: true,
    containerStyle: { position: 'absolute', top: remCalc(STUDENT_APP_DEFAULT_PADDING.y) },
  },
};

export const mainLayoutHeaderProps = (showBack, showFamilyResources) => {
  const backButton = showBack ? backButtonConfig : {};
  const familyResourcesButton = showFamilyResources ? familyResourcesButtonConfig : {};
  return {
    primaryLeftButton: { name: ButtonTypes.HOME_BUTTON },
    ...backButton,
    ...familyResourcesButton,
    primaryRightButton: {
      name: ButtonTypes.ACCESSIBILITY_BUTTON,
      showTextLabel: true,
    },
  };
};

export const activityReportTitle = (params) =>
  `${t('activityReport')} ${params.character ? ` - ${t('letter')} ${params.character}` : ''}`;

const getOverallProgress = (data: any) => {
  return (
    data?.characterProgress?.reduce(
      (acc, curr) => {
        if (!curr) return acc;
        return {
          bookReadCount: acc.bookReadCount + (curr.bookReadCount > 0 ? 1 : 0),
          totalBooks: data.characterProgress?.length,
          activityTotalCount: acc.activityTotalCount + (curr.activityTotalCount ?? 0),
          activityCompletedCount: acc.activityCompletedCount + (curr.activityCompletedCount ?? 0),
        };
      },
      {
        bookReadCount: 0,
        totalBooks: 0,
        activityTotalCount: 0,
        activityCompletedCount: 0,
      }
    ) ?? {}
  );
};

export const getStudentReport = (data: any) => {
  const overallData = getOverallProgress(data);

  const studentReport = [
    {
      description: t('booksRead'),
      completed: overallData.bookReadCount,
      total: overallData.totalBooks,
    },
    {
      description: t('activitiesCompleted'),
      completed: overallData.activityCompletedCount,
      total: overallData.activityTotalCount,
    },
  ];
  return studentReport;
};

export const getCharacterReport = (characterData: any) => {
  const characterReport = [
    {
      description: t('timesRead'),
      total: characterData?.bookReadCount,
    },
    {
      description: t('activitiesCompleted'),
      total: characterData?.activityCompletedCount,
    },
  ];
  return characterReport;
};

export const getCharacterIds = (assignments: any, letter?: string) => {
  if (!letter) {
    return assignments.map((assignment) => assignment?.character.id);
  }
  return assignments.reduce((acc, curr) => {
    if (curr.character?.character === letter) acc.push(curr.characterId);
    return acc;
  }, []);
};

export const getAllLettersWithAssignments = (assignments) => {
  return alphabet.map((letter) => {
    const foundAssignment = assignments?.find((a) => a.character.character === letter);
    if (foundAssignment) return { ...foundAssignment, assigned: true };
    return {
      character: {
        character: letter,
      },
      assigned: false,
    };
  });
};
